<template>
    <div id="content">
        <div class="container">
            <div v-if="message" class="user-activation">
                <div class="row">
                    <div class="col-md-6 offset-md-3">
                        <h1 class="mb-5">{{ $t('user_activation') }}</h1>
                        <div :class="['alert', `alert-${success ? 'success' : 'danger'}`]">{{ message }}</div>
                    </div>
                </div>
            </div>
        </div>
        <powered-by v-if="hasPoweredBy"/>
    </div>
</template>

<style lang="scss" scoped>
    .user-activation {
        text-align: center;

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }
    }
</style>

<script>
  import userActivation from 'src/mixins/userActivationPage';
  import PoweredBy from '../components/PoweredBy.vue';

  export default {
    mixins: [userActivation],
    components: {
      PoweredBy,
    },
  };
</script>